// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/bundle-" + "3bbf7c33a087186f6b59" + ".js";
};